module.exports = __webpack_public_path__ + "img/fast-forward.ed87c95f.svg";